// removed by extract-text-webpack-plugin
module.exports = {"description":"_2gEjzVvSXZ8pEBIPPM6in5"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/description/FetchCcusDescription.scss
// module id = 1372
// module chunks = 0